export * from './ngx-inactivity.module';



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/ngx-inactivity/src/app/ngx-inactivity/index.ts